let env_enum = {
  dev: 'dev',
  test: 'test',
  prod: 'prod',
};

let env = env_enum['prod'];

let server_address_enum = {
  'dev': 'http://test.com:8080',
  'test': 'http://tibdyg1.q01k.com',
  'prod': '/apissc',
};


let web_root_url = {
  'dev': `${window.location.protocol}//${window.location.host}`,
  'test': `${window.location.protocol}//${window.location.host}`,
  'prod': `${window.location.protocol}//${window.location.host}`,
};

let server_address = server_address_enum[env];
let server_root = web_root_url[env];

//0 导航栏在左边 1 导航栏在右边
let navigation_style = 0;


export { server_address, server_root, navigation_style };

export default env;



// WEBPACK FOOTER //
// ./src/env-config.js